var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{attrs:{"icon":"map-marker-alt","headline":_vm.$t('visitors.topCities.headline'),"description":_vm.$t('visitors.topCities.description')}},[_c('top-table',{attrs:{"limit":_vm.limit,"items":_vm.cities,"title":_vm.$t('visitors.topCities.city'),"visits":_vm.$t('visitors.topPages.visits')},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var item = ref.item;
var block = ref.block;
return [_c('div',{staticClass:"title animate",class:[ block ]},[_vm._v(" "+_vm._s(item.city)+" ")])]}},{key:"visits",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("numberFormat")(item.sessions))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }